import NewStaticTable from "components/staticTable/NewStaticTable"
import Modal from "global/Modal/Modal"
import React, { useEffect, useState } from "react"
import { getAPI } from "services/CRUDServices"
import { CreditHistoryColumns } from "./columns"
import { getDay } from "tools/functions/Methods"

function History({ open, setOpen, currentData }) {
  const [tableData, settableData] = useState([])
  useEffect(() => {
    getAPI(`/core-api/hub_credit/logCredit/${currentData.id}`).then((res) => {
      console.log(res.data)

      const response = res.data.payload.map((item) => ({
        ...item,
        creditExpirationDate:
          !!item.creditExpirationDate && getDay(item.creditExpirationDate),
        createDateTime: !!item.createDateTime && getDay(item.createDateTime),
      }))

      settableData(response)
    })
  }, [])

  return (
    <Modal visible={open} setVisible={setOpen} title='سوابق '>
      <NewStaticTable
        data={tableData}
        HoleClassName={"w-[20rem] "}
        THWrapper={"whitespace-nowrap"}
        // pagination={settlementData?.payload?.totalElements}

        column={CreditHistoryColumns}
        ignoreRedux={true}
      />
    </Modal>
  )
}

export default History
